export const API ={
    emailJs:'https://api.emailjs.com/api/v1.0/email/send'
}